import React from 'react';

export const formatPrice = (price) => {
  if (price == null) return null;
  return new Intl.NumberFormat('fr-FR').format(price) + ' FCFA';
};

export const countryOptions = [
  { code: '+225', label: 'Côte d\'Ivoire', iso: 'CI' },
  { code: '+228', label: 'Togo', iso: 'TG' },
  { code: '+229', label: 'Bénin', iso: 'BJ' },
  { code: '+223', label: 'Mali', iso: 'ML' },
  { code: '+221', label: 'Sénégal', iso: 'SN' },
  { code: '+226', label: 'Burkina Faso', iso: 'BF' },
  { code: '+224', label: 'Guinée', iso: 'GN' },
  { code: '+245', label: 'Guinée-Bissau', iso: 'GW' },
  { code: '+227', label: 'Niger', iso: 'NE' },
  { code: '+234', label: 'Nigéria', iso: 'NG' },
  { code: '+220', label: 'Gambie', iso: 'GM' },
  { code: '+233', label: 'Ghana', iso: 'GH' },
];

export const prefixByIso = countryOptions.reduce((acc, o) => { acc[o.iso] = o.code; return acc; }, {});
export const isoByPrefix = countryOptions.reduce((acc, o) => { acc[o.code] = o.iso; return acc; }, {});

export const BackIcon = () => (
  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
  </svg>
);

export const CloseIcon = () => (
  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
  </svg>
);

export const Spinner = ({ size = 'md' }) => (
  <div className={`${size === 'sm' ? 'w-4 h-4 border-2' : 'w-5 h-5 border-2'} border-gray-300 border-t-gray-800 rounded-full animate-spin`} />
);

export const WhatsAppFAB = ({ number, message, bottomOffset = 'bottom-6' }) => (
  <a
    href={`https://wa.me/${number.replace(/\D/g, '')}?text=${encodeURIComponent(message)}`}
    target="_blank"
    rel="noopener noreferrer"
    className={`fixed ${bottomOffset} right-4 z-20 w-14 h-14 rounded-full flex items-center justify-center shadow-lg transition-transform active:scale-95 hover:scale-105`}
    style={{ backgroundColor: '#25D366' }}
    aria-label="Contacter sur WhatsApp"
  >
    <svg viewBox="0 0 24 24" fill="white" width="28" height="28">
      <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z"/>
      <path d="M12 0C5.373 0 0 5.373 0 12c0 2.124.558 4.121 1.533 5.851L.057 23.714a.5.5 0 0 0 .63.63l5.862-1.476A11.95 11.95 0 0 0 12 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 22c-1.881 0-3.64-.514-5.145-1.407l-.368-.219-3.821.962.981-3.82-.228-.374A10 10 0 0 1 2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10z"/>
    </svg>
  </a>
);

export const ProductPlaceholder = () => (
  <div className="aspect-[4/3] bg-gray-100 rounded-xl flex items-center justify-center">
    <svg width="40" height="40" viewBox="0 0 24 24" fill="none">
      <rect x="3" y="3" width="18" height="18" rx="2" stroke="#d1d5db" strokeWidth="1.5"/>
      <circle cx="8.5" cy="8.5" r="1.5" stroke="#d1d5db" strokeWidth="1.5"/>
      <path d="M3 15l5-5 4 4 3-3 6 6" stroke="#d1d5db" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  </div>
);
